import React from "react";
import { FaUserTie } from "react-icons/fa6";
import { GiTakeMyMoney } from "react-icons/gi";
import { MdCampaign } from "react-icons/md";

const CampaignBasicInfo = ({ campaignData }) => {
  return (
    <div className="personal_info w-100 bg-white">
      <div>
        <div className="d-flex align-items-center">
          <div className="camp_user">
            <FaUserTie />
          </div>
          <div>
            <p className="light_text">My POC</p>
            <p className="name text-capitalize">
              {campaignData?.salesPersonName}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div className="camp_user">
            <GiTakeMyMoney />
          </div>
          <div>
            <p className="light_text">My Payout</p>
            <p className="name text-capitalize">
              {campaignData?.influencersBudget?.toLowerCase() === "none"
                ? campaignData?.influencersBudget
                : "₹ " + campaignData?.influencersBudget?.toLocaleString()}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div className="camp_user">
            <MdCampaign />
          </div>
          <div>
            <p className="light_text">Campaign Type</p>
            <p className="name text-capitalize">{campaignData?.campaignType}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignBasicInfo;
